/**
 * Affiliate- und Fulfillment-Admin liegen unter `/[locale]/admin/...` (nicht channel-scoped).
 * Dort soll posthog-js keine Events senden und keine Session Recordings erzeugen.
 */
export function isRecoveryPath(pathname: string): boolean {
	const segments = pathname.split("/").filter(Boolean);
	return segments.length >= 3 && segments[1] === "checkout" && segments[2] === "recover";
}

export function isPostHogSuppressedPath(pathname: string): boolean {
	const segments = pathname.split("/").filter(Boolean);
	return (segments.length >= 2 && segments[1] === "admin") || isRecoveryPath(pathname);
}
